export default __webpack_public_path__ + "static/media/refridgerator.d0d571f8.jpg";